import React, { useState } from 'react';
import '../styles/Checkout.css';

const Checkout = ({ onVolver, productosValidos, tipoEntrega, total }) => {
  const [paso, setPaso] = useState(1);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');

  const [datosEnvio, setDatosEnvio] = useState({
    nombre: '',
    email: '',
    telefono: '',
    direccion: '',
    ciudad: '',
    codigoPostal: '',
  });

  const handleCambio = (e) => {
    const { name, value } = e.target;
    setDatosEnvio(prev => ({ ...prev, [name]: value }));
    setError('');
  };

  const validar = () => {
    if (!datosEnvio.nombre.trim())                              { setError('Por favor ingresá tu nombre'); return false; }
    if (!datosEnvio.email.trim() || !datosEnvio.email.includes('@')) { setError('Por favor ingresá un email válido'); return false; }
    if (!datosEnvio.telefono.trim())                            { setError('Por favor ingresá tu teléfono'); return false; }
    if (!datosEnvio.direccion.trim())                           { setError('Por favor ingresá tu dirección'); return false; }
    if (!datosEnvio.ciudad.trim())                              { setError('Por favor ingresá tu ciudad'); return false; }
    if (!datosEnvio.codigoPostal.trim())                        { setError('Por favor ingresá tu código postal'); return false; }
    return true;
  };

  const irAPaso2 = () => {
    if (validar()) { setPaso(2); setError(''); }
  };

  const pagarConMP = async () => {
    setCargando(true);
    setError('');
    try {
      const costoEnvio = tipoEntrega === 'envio' ? 5000 : 0;
      const res = await fetch('/api/mercadopago/preferencia', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          cliente: datosEnvio,
          productos: productosValidos,
          tipoEntrega,
          costoEnvio,
          total,
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Error al conectar con MercadoPago');
      window.location.href = data.checkout_url;
    } catch (err) {
      setError(err.message);
      setCargando(false);
    }
  };

  const costoEnvio = tipoEntrega === 'envio' ? 5000 : 0;
  const subtotal   = productosValidos.reduce((acc, p) => acc + p.precio * p.cantidad, 0);

  return (
    <div className="checkout-container">
      <div className="checkout-header">
        <h2>Checkout</h2>
        <button className="btn-cerrar-checkout" onClick={onVolver}>✕</button>
      </div>

      <div className="checkout-contenido">

        {/* Indicador de pasos */}
        <div className="checkout-pasos">
          <div className={`paso ${paso >= 1 ? 'activo' : ''}`}>
            <span className="numero-paso">1</span>
            <span className="nombre-paso">Envío</span>
          </div>
          <div className={`linea-paso ${paso >= 2 ? 'activo' : ''}`}></div>
          <div className={`paso ${paso >= 2 ? 'activo' : ''}`}>
            <span className="numero-paso">2</span>
            <span className="nombre-paso">Pago</span>
          </div>
        </div>

        {/* PASO 1: DATOS DE ENVÍO */}
        {paso === 1 && (
          <div className="paso-contenido">
            <h3>Información de Envío</h3>
            <form className="formulario-envio" onSubmit={e => { e.preventDefault(); irAPaso2(); }}>
              <div className="form-grupo">
                <label htmlFor="nombre">Nombre Completo *</label>
                <input type="text" id="nombre" name="nombre" value={datosEnvio.nombre}
                  onChange={handleCambio} placeholder="Ej: Juan Pérez" />
              </div>
              <div className="form-fila">
                <div className="form-grupo">
                  <label htmlFor="email">Email *</label>
                  <input type="email" id="email" name="email" value={datosEnvio.email}
                    onChange={handleCambio} placeholder="Ej: juan@ejemplo.com" />
                </div>
                <div className="form-grupo">
                  <label htmlFor="telefono">Teléfono *</label>
                  <input type="tel" id="telefono" name="telefono" value={datosEnvio.telefono}
                    onChange={handleCambio} placeholder="Ej: +54 9 11 2345 6789" />
                </div>
              </div>
              <div className="form-grupo">
                <label htmlFor="direccion">Dirección *</label>
                <input type="text" id="direccion" name="direccion" value={datosEnvio.direccion}
                  onChange={handleCambio} placeholder="Ej: Calle Principal 123" />
              </div>
              <div className="form-fila">
                <div className="form-grupo">
                  <label htmlFor="ciudad">Ciudad *</label>
                  <input type="text" id="ciudad" name="ciudad" value={datosEnvio.ciudad}
                    onChange={handleCambio} placeholder="Ej: Buenos Aires" />
                </div>
                <div className="form-grupo">
                  <label htmlFor="codigoPostal">Código Postal *</label>
                  <input type="text" id="codigoPostal" name="codigoPostal" value={datosEnvio.codigoPostal}
                    onChange={handleCambio} placeholder="Ej: 1425" />
                </div>
              </div>

              {error && <div className="error-mensaje">{error}</div>}

              <button type="submit" className="btn-siguiente">
                Continuar al Pago →
              </button>
            </form>
          </div>
        )}

        {/* PASO 2: PAGO CON MERCADOPAGO */}
        {paso === 2 && (
          <div className="paso-contenido">
            <h3>Pago seguro</h3>

            <div className="mp-info">
              <p>Serás redirigido al sitio seguro de <strong>MercadoPago</strong> para completar el pago.</p>
              <p>Podés pagar con tarjeta de crédito, débito, o dinero en cuenta de MercadoPago.</p>
            </div>

            <div className="mp-resumen-pago">
              <span className="mp-resumen-label">Total a pagar</span>
              <span className="mp-resumen-total">${total.toLocaleString('es-AR')}</span>
            </div>

            {error && <div className="error-mensaje">{error}</div>}

            <div className="botones-paso">
              <button type="button" className="btn-volver-paso" onClick={() => { setPaso(1); setError(''); }} disabled={cargando}>
                ← Volver
              </button>
              <button type="button" className="btn-mp" onClick={pagarConMP} disabled={cargando}>
                {cargando
                  ? <span className="mp-btn-cargando">⏳ Conectando...</span>
                  : <><span className="mp-btn-logo">MP</span> Pagar con MercadoPago</>
                }
              </button>
            </div>
          </div>
        )}

        {/* RESUMEN LATERAL */}
        <div className="checkout-resumen">
          <h4>Resumen de tu Compra</h4>
          <div className="items-resumen">
            {productosValidos.map(prod => (
              <div key={prod._id} className="item-resumen">
                <span>{prod.nombre}</span>
                <span>×{prod.cantidad}</span>
                <span>${(prod.precio * prod.cantidad).toLocaleString('es-AR')}</span>
              </div>
            ))}
          </div>
          <div className="linea-separadora"></div>
          <div className="resumen-totales">
            <div className="resumen-fila-total">
              <span>Subtotal:</span>
              <span>${subtotal.toLocaleString('es-AR')}</span>
            </div>
            {tipoEntrega === 'envio' && (
              <div className="resumen-fila-total">
                <span>Envío:</span>
                <span>${costoEnvio.toLocaleString('es-AR')}</span>
              </div>
            )}
            <div className="resumen-fila-total total-final">
              <span>Total:</span>
              <span>${total.toLocaleString('es-AR')}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Checkout;
